import request from "./request";

// 获取时间源
export const getTimeStamp = (params) => {
  return request({
    url: '/tsa/timestamp?time='+ new Date().getTime(),
    method: 'get',
    // params
  })
}
// 获取验证码
export const getTSACode = (params) => {
  return request({
    url: '/tsa/code?time='+ new Date().getTime(),
    method: 'get',
    // params
  })
}
// 验证图片验证码
export const codeVerify = (data) => {
  return request({
    url: '/tsa/code/verify',
    method: 'post',
    data
  })
}
// 验证时间戳
export const TSAVerify = (data) => {
  return request({
    url: '/tsa/verify',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js